import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import { SvgIcon } from "../../components/SvgComponents";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
  frame: number;
  fps: number;
}

export const VectorMotionIntro: React.FC<IntroProps> = ({
  headline,
  keywords,
  introIcon,
  frame,
  fps,
}) => {
  const floatY = Math.sin(frame * 0.05) * 12;
        const svgScale = spring({
          frame,
          fps,
          config: { damping: 12, mass: 0.5, stiffness: 140 },
        });
        const svgOpacity = interpolate(frame, [0, 8], [0, 1], {
          extrapolateLeft: "clamp",
          extrapolateRight: "clamp",
        });

        return (
          <div
            style={{
              width: "100%",
              padding: "35px 25px 25px 25px",
              background: "rgba(255, 255, 255, 0.75)",
              backdropFilter: "blur(12px)",
              WebkitBackdropFilter: "blur(12px)",
              border: "2px solid #ffb7d5",
              borderRadius: "28px",
              boxShadow: "0 8px 32px rgba(200, 164, 255, 0.2)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: "24px",
            }}
          >
            {/* Takeaway Pill Badge */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 16px",
                borderRadius: "50px",
                background: "rgba(255, 183, 213, 0.6)",
                border: "2px solid #ffb7d5",
                color: "#2d1b3d",
                fontFamily: "'Nunito', sans-serif",
                fontWeight: 800,
                fontSize: "13px",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                boxShadow: "0 4px 15px rgba(255, 183, 213, 0.2)",
              }}
            >
              ✨ TRENDING NOW ✨
            </div>

            {/* Headline */}
            <h1
              style={{
                fontFamily: "'Nunito', sans-serif",
                fontSize: "48px",
                fontWeight: 800,
                lineHeight: 1.3,
                color: "#2d1b3d",
                margin: 0,
              }}
            >
              {headline}
            </h1>

            {/* Big SVG Illustration matched to the headline */}
            <div
              style={{
                width: "100%",
                height: "280px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: svgOpacity,
                transform: `scale(${svgScale}) translateY(${floatY}px)`,
                overflow: "visible",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  filter: "drop-shadow(0 15px 30px rgba(200, 164, 255, 0.45))",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SvgIcon
                  name={introIcon || "undraw-astronaut-0o7w"}
                  width={280}
                  height={280}
                  primaryColor="#c8a4ff"
                />
              </div>
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
